"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = level2;
var _unionBy = _interopRequireDefault(require("lodash/unionBy"));
var _differenceBy = _interopRequireDefault(require("lodash/differenceBy"));
var _level2Actions = require("../actions/level2Actions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var initialState = getDefaultState();
var descendingPrice = function descendingPrice(a, b) {
  return b.Price - a.Price;
};
function level2() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments.length > 1 ? arguments[1] : undefined,
    type = _ref.type,
    payload = _ref.payload;
  switch (type) {
    case _level2Actions.REQUEST_LEVEL_2_DATA:
      return _objectSpread(_objectSpread({}, state), {}, {
        fetching: true
      });
    case _level2Actions.RECEIVE_LEVEL_2_DATA:
      return handleGetAllLevel2Data(state, payload);
    case _level2Actions.LEVEL_2_UPDATES:
      return handleLevel2Updates(state, payload);
    case _level2Actions.UNSUBSCRIBE_LEVEL2:
      return getDefaultState();
    default:
      {
        return state;
      }
  }
}
var handleGetAllLevel2Data = function handleGetAllLevel2Data(state, payload) {
  var data = mapOrders(payload);
  return _objectSpread(_objectSpread({}, state), {}, {
    sell: data.sell.sort(descendingPrice),
    buy: data.buy.sort(descendingPrice),
    fetching: false
  });
};
function handleLevel2Updates(state, payload) {
  var updates = mapOrders(payload);
  return _objectSpread(_objectSpread({}, state), {}, {
    buy: mergeOrders(state.buy, updates.buy),
    sell: mergeOrders(state.sell, updates.sell),
    "short": [].concat(_toConsumableArray(state["short"]), _toConsumableArray(updates["short"])),
    unknown: [].concat(_toConsumableArray(state.unknown), _toConsumableArray(updates.unknown))
  });
}
var deleteType = 2;
var mergeOrders = function mergeOrders(state, updates) {
  var updatesToDelete = [];
  var updatesToMerge = [];
  updates.forEach(function (update) {
    if (update.ActionType === deleteType) {
      var position = updatesToMerge.findIndex(function (item) {
        return item.Price === update.Price;
      });
      if (position !== -1) {
        updatesToMerge = updatesToMerge.filter(function (i) {
          return i.Price !== update.Price;
        });
      }
      updatesToDelete.push(update);
    } else {
      updatesToMerge.push(update);
    }
  });
  var filteredState = (0, _differenceBy["default"])(state, updatesToDelete, function (x) {
    return x.Price;
  });
  return (0, _unionBy["default"])(
  /**
   * @NOTE
   *  this sorting is needed to give precedence to newer updates,
   *  when Level2UpdateEvent contains multiple ActionType=Update entries for same price level.
   */
  updatesToMerge.sort(function (a, b) {
    return b.UpdateId - a.UpdateId;
  }), filteredState, function (x) {
    return x.Price;
  }).sort(descendingPrice);
};
function getDefaultState() {
  return {
    buy: [],
    sell: [],
    "short": [],
    unknown: [],
    fetching: false
  };
}
function mapOrders(data) {
  var result = {
    buy: [],
    sell: [],
    "short": [],
    unknown: []
  };
  data.forEach(function (update) {
    switch (update.Side) {
      case 0:
        result.buy.push(update);
        break;
      case 1:
        result.sell.push(update);
        break;
      case 2:
        result["short"].push(update);
        break;
      default:
        result.unknown.push(update);
        break;
    }
  });
  return result;
}